import {
  getUserDetails,
  getDefaultEmailNotificationSettings,
  getAccountInfo,
  getLimitedAccessLookup,
  getDataTransmissionAccess,
  getUserAccountInfo,
  getAdminSettings,
  externalUserDtPermissions,
} from 'src/utils/urls';

import {
  UserDetailsType,
  UsersListType,
} from 'src/features/Users/types/usersListType';
import {
  ApiParamType,
  DefaultNotificationResponseType,
} from '../types/userStoreTypes';
import { LimitedAccessLookup } from '../types/limitedAccessRecords';
import { LimitedAccessLookupType } from '../types/limitedAccessRecords';
import { AccountInfo } from 'src/types/AccountInfo';
import { AccountInfoId } from 'src/types/AccountInfo';
import {
  AdminSettingsResponseType,
  AdminSettingsType,
} from 'src/features/AddEditUsers/types/adminSettings';
import { useSaveChangesParamStore } from 'src/store/useSaveChangesParamStore';

import { LimitedAccessLookupTypeRevamp } from '../api/useGetLimitedAccessRecord';

// fetch user details during edit operation
export async function fetchUserDetails({
  id,
  token,
  tokenType,
}: Partial<{
  id: string;
  token: string;
  tokenType: string;
}>): Promise<UserDetailsType | undefined> {
  if (id) {
    const response = await fetch(getUserDetails(id), {
      method: 'GET',
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });
    return response.json();
  }
}

// default email notification during create a user
export async function fetchDefaultEmailNotificationSettings({
  token,
  tokenType,
}: Partial<ApiParamType>): Promise<DefaultNotificationResponseType> {
  const response = await fetch(getDefaultEmailNotificationSettings, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

//fetch all account details with out pagination when create
export async function fetchAccountInfo({
  token,
  tokenType,
  id,
}: Partial<{
  token: string;
  tokenType: string;
  id: string | undefined;
}>): Promise<AccountInfoId> {
  const response = await fetch(id ? getUserAccountInfo(id) : getAccountInfo, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

//fetch all account details with out pagination when create
export async function fetchUserAccountInfo({
  token,
  tokenType,
  id,
}: Partial<{
  token: string;
  tokenType: string;
  id: string;
}>): Promise<AccountInfoId> {
  const response = await fetch(getAccountInfo, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

//fetch all lookup for the accounts
export async function fetchLimittedAcessLookup({
  id,
  token,
  tokenType,
  userId,
}: Partial<{
  id: number;
  token: string;
  tokenType: string;
  userId: string | undefined;
}>): Promise<LimitedAccessLookupTypeRevamp | undefined> {
  const uId = userId ? userId : null;
  if (id) {
    const response = await fetch(getLimitedAccessLookup(id, uId), {
      method: 'GET',
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });
    return response.json();
  }
}

//fetch the records of account lookups
export async function fetchLimittedAccessLookupRecords({
  token,
  tokenType,
  accountId,
  recordId,
}: Partial<{
  token: string;
  tokenType: string;
  accountId: number;
  recordId: number;
}>): Promise<LimitedAccessLookup | undefined> {
  if (accountId && recordId) {
    const response = await fetch(
      getDataTransmissionAccess(accountId, recordId),
      {
        method: 'GET',
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      },
    );
    return response.json();
  }
}

export async function fetchAdminSettings({
  token,
  tokenType,
}: Partial<ApiParamType>): Promise<AdminSettingsResponseType> {
  const response = await fetch(getAdminSettings, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

export async function fetchLoggedInExternalUserDtPermissions({
  id,
  token,
  tokenType,
}: Partial<{
  id: string | undefined;
  token: string;
  tokenType: string;
}>): Promise<AccountInfoId> {
  const response = await fetch(externalUserDtPermissions(id), {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}
